/**
 * Ensure multi-day package services are assigned across Day 1…N.
 * Hero offers sometimes have total_days > 1 but every service still day_number=1,
 * which caused only one appointment to be created.
 */
export function distributeServicesForMultiDay(services = [], totalDays = 1) {
  const days = Math.max(1, Number(totalDays) || 1)
  const list = (Array.isArray(services) ? services : []).map((s) => ({
    ...s,
    day_number: Number(s?.day_number) || 1,
  }))

  if (days <= 1 || list.length === 0) return list

  const uniqueDays = new Set(list.map((s) => s.day_number))
  const maxDay = Math.max(...list.map((s) => s.day_number))

  // Already spread across the package days
  if (uniqueDays.size >= 2 && maxDay >= Math.min(days, 2)) {
    return list.map((s) => ({
      ...s,
      day_number: Math.min(Math.max(s.day_number, 1), days),
    }))
  }

  // Fallback: split services evenly across N days (preserves order)
  const perDay = Math.ceil(list.length / days)
  return list.map((s, index) => ({
    ...s,
    day_number: Math.min(days, Math.floor(index / perDay) + 1),
  }))
}

export function servicesForDay(services = [], dayNum = 1) {
  const day = Number(dayNum) || 1
  return (services || []).filter((s) => (Number(s?.day_number) || 1) === day)
}
